if (process.env.HTTPSERVER === 'gqc' || process.env.HTTPSERVER === 'ip') {
    // 引入vsconle
    const script = document.createElement('script')
    script.src = 'http://atour-wechat.qiniu.yaduo.com/js/lib/vconsole.min.js'
    script.onload = () => {
        /* eslint-disable */
        new VConsole()
    }
    document.body.appendChild(script)
}

const navigator = window.navigator

function loadSdkJS() {
    const agent = navigator.userAgent.toLowerCase()
    let sdkUrl = ''
    if (agent.indexOf('micromessenger') !== -1) { // 微信环境
        sdkUrl = 'https://res2.wx.qq.com/open/js/jweixin-1.6.0.js'
    } else if (agent.indexOf('alipayclient') > -1) { // 支付宝环境
        sdkUrl = 'https://appx/web-view.min.js'
    }
    return new Promise((resolve, reject) => {
        if (sdkUrl) {
            const script = document.createElement('script')
            script.src = sdkUrl
            script.onload = () => {
                // 加载sdk完成后
                resolve()
            }
            document.body.appendChild(script)
        } else {
            resolve()
        }
        
    })
}

function isMiniApp (resolve, reject) {
    const agent = navigator.userAgent.toLowerCase()
    if (agent.indexOf('micromessenger') > -1 || agent.indexOf('wechatdevtools') > -1) {
        console.log(wx)
        wx && wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
                console.log('微信小程序')
                resolve({
                    body: wx,
                    type: 'wechat'
                })
            } else {
                console.log('微信小程序1')
                reject()
            }
        })
    } else if (agent.indexOf('alipayclient') > -1) {
        my && my.getEnv((res) => {
            if (res.miniprogram) {
                console.log('支付宝小程序')
                resolve({
                    body: my,
                    type: 'alipay'
                })
            } else {
                console.log('支付宝小程序1')
                reject()
            }
        })
    } else {
        console.log('不在小程序')
        reject()
    }
}

function judgeMiniApp () {
    return new Promise((resolve, reject) => {
        if ((window.wx && window.wx.miniProgram) || window.my) {
            isMiniApp(resolve, reject)
        } else {
            loadSdkJS().then(() => {
                isMiniApp(resolve, reject)
            })
        }
    })
}

function nativeHref(to, data) {
    Prius.appEventCallback({event: to,data: (data || {})})
}

function goToIndex() {
    if (Prius && Prius.isInsideApp) {
        Prius.backpage({})
    } else {
        judgeMiniApp().then(({ body, type }) => {
            console.log('是小程序')
            if (type === 'alipay') {
                body.switchTab({
                    url: '/pages/index/index'
                })
            } else {
                body.miniProgram.switchTab({
                    url: '/pages/index/index'
                })
            }
        }).catch(() => {
            window.location.href = window.location.protocol + '//wechat.yaduo.com/'
        })
    }
}

function goToTicket() {
    if (Prius && Prius.isInsideApp) {
        nativeHref('USERCOUPONS', {couponType: 2})
    } else {
        judgeMiniApp().then(({ body, type }) => {
            console.log('是小程序')
            if (type === 'alipay') {
                body.miniProgram.navigateTo({
                    url: '/pages/CouponsPackage/CouponsPackage'
                })
            } else {
                // 支付宝小程序
                body.miniProgram.navigateTo({
                    url: '/pages/WebView/WebView?url=https://wechat.yaduo.com/atour/coupon'
                })
            }
        }).catch(() => {
            window.location.href = window.location.protocol + '//wechat.yaduo.com/atour/coupon'
        })
    }
}

export { goToIndex }
export { goToTicket }



// WEBPACK FOOTER //
// ./src/utils.js